import { __assign, __rest } from "tslib";
import React, { useContext } from "react";
import classNames from "classnames";
import { CheckContext } from "../check";
import { Text } from "../text";
import { useDefaultValue } from "../form/controlled";
import { callBoth } from "../_util/call-both";
import { Tooltip } from "../tooltip";
import { useConfig } from "../_util/config-context";
import { noop } from "../_util/noop";
export var Switch = React.forwardRef(function Switch(props, ref) {
    var classPrefix = useConfig().classPrefix;
    // 支持从 Context 注入
    var context = useContext(CheckContext);
    if (context) {
        var checkProps = context.inject(__assign({ type: "checkbox" }, props));
        delete checkProps.type;
        // eslint-disable-next-line no-param-reassign
        props = checkProps;
    }
    var _a = useDefaultValue(props, false), name = _a.name, value = _a.value, disabled = _a.disabled, _b = _a.onChange, onChange = _b === void 0 ? noop : _b, _c = _a.onClick, onClick = _c === void 0 ? noop : _c, loading = _a.loading, tooltip = _a.tooltip, children = _a.children, className = _a.className, extraProps = __rest(_a, ["name", "value", "disabled", "onChange", "onClick", "loading", "tooltip", "children", "className"]);
    var component = (React.createElement("label", __assign({ ref: children ? undefined : ref, className: classNames(classPrefix + "-switch", { "is-loading": loading }, className) }, (children ? {} : extraProps)),
        React.createElement("input", { readOnly: true, type: "checkbox", className: classPrefix + "-switch__input", checked: value, disabled: disabled || loading, onClick: callBoth(children ? noop : onClick, function (event) {
                var checked = event.currentTarget.checked;
                onChange(checked, {
                    event: event,
                    check: __assign(__assign({ type: "checkbox" }, props), { value: checked }),
                });
            }) }),
        React.createElement("span", { className: classPrefix + "-switch__toggle" })));
    // 默认是不需要 children 的，如果提供了，需要包装一层
    if (children) {
        component = (React.createElement("label", __assign({ ref: ref, onClick: function (event) {
                var _a;
                // 多次触发
                if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.tagName) !== "SPAN") {
                    onClick(event);
                }
            }, style: { cursor: disabled ? "default" : "pointer" } }, extraProps),
            component,
            React.createElement(Text, { reset: true, style: { verticalAlign: "middle", margin: "0 5px" } }, children)));
    }
    if (tooltip) {
        component = React.createElement(Tooltip, { title: tooltip }, component);
    }
    return component;
});
Switch.displayName = "Switch";
//# sourceMappingURL=Switch.js.map